import React, { useEffect, useState } from 'react';
import './HistoryModal.css';
import { useData } from './AuthContext';

const HistoryModal = ({ isOpen, onClose }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [isFadingIn, setIsFadingIn] = useState(false);

    const { 
        savedCalculations, 
        remoteCalculations = [], 
        syncCalculationToRemote, 
        generateProductUrl, 
        deleteSavedCalculation,
        isLoggedIn
    } = useData();

    const isCalculationSynced = (id) => {
        return remoteCalculations.some(remote => remote.data?.id === id);
    };


  useEffect(() => {
    if (isOpen) {
        setIsVisible(true);
        document.documentElement.style.overflow = 'hidden';
        document.body.style.overflow = 'hidden';
        const timeout = setTimeout(() => setIsFadingIn(true), 10);
        return () => clearTimeout(timeout);
    } else {
        setIsFadingIn(false);
        const timeout = setTimeout(() => {
            setIsVisible(false);
            document.documentElement.style.overflow = '';
            document.body.style.overflow = '';
        }, 300);
        return () => clearTimeout(timeout);
    }
  }, [isOpen]);

  if (!isVisible) return null;

  return (
    <div className={`history-menu-modal-overlay ${isFadingIn ? 'fade-in' : 'fade-out'}`}>
      <div className="history-menu-modal">
        <div className="history-input-container">
          <button className="history-close-button" onClick={onClose}>
            &times;
          </button>
          <ul className="styled-calculation-list">
            {[...(savedCalculations || [])]
              .toReversed()
              .map((calc) => {
                const uValue = calc.result?.uvalue;
                return (
                  <li key={calc.id} className="styled-card">
                    <div className="card-header">
                        <div style={{display: "flex", alignItems: "center"}}>
                            <span className="calculation-name">
                                {calc.name || 'Unnamed Calculation'}
                            </span>
                            {isLoggedIn && !isCalculationSynced(calc.id) && (
                                <button
                                    className="delete-button"
                                    title="Sync to cloud"
                                    onClick={() => syncCalculationToRemote(calc.id)}
                                    aria-label="Sync calculation"
                                >
                                    <img src='./sync.svg' width={"20px"} height={"20px"} />
                                </button>
                            )}
                        </div>
                      <button
                        className="delete-button"
                        onClick={() => deleteSavedCalculation(calc.id)}
                        aria-label="Delete item"
                      >
                        <svg
                          className="delete-icon"
                          width="16"
                          height="16"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <path d="M3 6h18"></path>
                          <path d="M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6"></path>
                          <path d="M8 6V4a2 2 0 012-2h4a2 2 0 012 2v2"></path>
                          <line x1="10" y1="11" x2="10" y2="17"></line>
                          <line x1="14" y1="11" x2="14" y2="17"></line>
                        </svg>
                      </button>
                    </div>
                    <a
                      href={generateProductUrl(calc.product, calc.formData)}
                      className="card-body"
                      rel="noopener noreferrer"
                    >
                      <div className="date-text">
                        {new Date(calc.date).toLocaleDateString()}
                      </div>
                      <div className="uvalue-row">
                        {uValue !== undefined && (
                          <span className="uvalue">
                            {uValue.toFixed(2)} <span className="uvalue-label">W/m²K</span>
                          </span>
                        )}
                      </div>
                    </a>
                  </li>
                );
              })}
            {savedCalculations.length === 0 && (
              <li className="quote-history-item empty">No saved calculations.</li>
            )}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default HistoryModal;
